// Copyright 2022 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license, please see LICENSE.md in the
// project root for license information or contact permission@sei.cmu.edu for full terms.
export enum TopbarView {
  CITE_ADMIN = 'cite-admin',
  CITE_HOME = 'cite-home',
}
